import { fireBIEvent } from 'public/bi-event.js';
const pageUrl = "https://www.wix.com/essentials/get-started";

$w.onReady(function () {
    clickOnPrimaryCtaBiEvent();
    clickOnSupportArticleBiEvent();
    clickOnSecondaryCtaBiEvent();
    watchVideoBiEvent();

});

//event 9000 
const clickOnSupportArticleBiEvent = () => {

    const ctas = [{
            id: '#button69',
            articleName: $w('#button69').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button69').link,
        },
        {
            id: '#button78',
            articleName: $w('#button78').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button78').link,
        },
        {
            id: '#button68',
            articleName: $w('#button68').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button68').link,
        },

        {
            id: '#button72',
            articleName: $w('#button72').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Organize your pages',
            targetUrl: $w('#button72').link,
        },
        {
            id: '#button71',
            articleName: $w('#button71').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Organize your pages',
            targetUrl: $w('#button71').link,
        },
        {
            id: '#button70',
            articleName: $w('#button70').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Organize your pages',
            targetUrl: $w('#button70').link,
        },

        {
            id: '#button75',
            articleName: $w('#button75').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Edit for mobile',
            targetUrl: $w('#button75').link,
        },
        {
            id: '#button74',
            articleName: $w('#button74').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Edit for mobile',
            targetUrl: $w('#button74').link,
        },
        {
            id: '#button73',
            articleName: $w('#button73').label,
            articleCategory: 'Start your site',
            articleSubCategory: 'Edit for mobile',
            targetUrl: $w('#button73').link,
        },

        {
            id: '#button43',
            articleName: $w('#button43').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Get a custom domain',
            targetUrl: $w('#button43').link,
        },
        {
            id: '#button42',
            articleName: $w('#button42').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Get a custom domain',
            targetUrl: $w('#button42').link,
        },
        {
            id: '#button41',
            articleName: $w('#button41').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Get a custom domain',
            targetUrl: $w('#button41').link,
        },

        {
            id: '#button39',
            articleName: $w('#button39').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Manage your site',
            targetUrl: $w('#button39').link,
        },
        {
            id: '#button38',
            articleName: $w('#button38').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Manage your site',
            targetUrl: $w('#button38').link,
        },
        {
            id: '#button37',
            articleName: $w('#button37').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Manage your site',
            targetUrl: $w('#button37').link,
        },

        {
            id: '#button36',
            articleName: $w('#button36').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Streamline your workflow',
            targetUrl: $w('#button36').link,
        },
        {
            id: '#button35',
            articleName: $w('#button35').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Streamline your workflow',
            targetUrl: $w('#button35').link,
        },
        {
            id: '#button34',
            articleName: $w('#button34').label,
            articleCategory: 'Manage and optimize',
            articleSubCategory: 'Streamline your workflow',
            targetUrl: $w('#button34').link,
        },

        {
            id: '#button52',
            articleName: $w('#button52').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Optimize your SEO',
            targetUrl: $w('#button52').link,
        },
        {
            id: '#button51',
            articleName: $w('#button51').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Optimize your SEO',
            targetUrl: $w('#button51').link,
        },
        {
            id: '#button50',
            articleName: $w('#button50').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Optimize your SEO',
            targetUrl: $w('#button50').link,
        },

        {
            id: '#button49',
            articleName: $w('#button49').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Promote your site',
            targetUrl: $w('#button49').link,
        },
        {
            id: '#button48',
            articleName: $w('#button48').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Promote your site',
            targetUrl: $w('#button48').link,
        },
        {
            id: '#button47',
            articleName: $w('#button47').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Promote your site',
            targetUrl: $w('#button47').link,
        },

        {
            id: '#button46',
            articleName: $w('#button46').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Connect with customers',
            targetUrl: $w('#button46').link,
        },
        {
            id: '#button45',
            articleName: $w('#button45').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Connect with customers',
            targetUrl: $w('#button45').link,
        },
        {
            id: '#button44',
            articleName: $w('#button44').label,
            articleCategory: 'Keep on growing',
            articleSubCategory: 'Connect with customers',
            targetUrl: $w('#button44').link,
        },

    ];

    ctas.forEach((cta) => {
        const {
            id,
            articleCategory,
            articleName,
            articleSubCategory,
            targetUrl,
        } = cta;
        $w(id).onClick(() => {

            const biFields = {
                articleCategory,
                articleName,
                articleSubCategory,
                targetUrl,
                pageUrl,
            }
            fireBIEvent(19, 9000, biFields);
        });
    });
}

//event 9001 
const clickOnPrimaryCtaBiEvent = () => {
    const ctas = [{
        id: '#getStartedButton',
        ctaName: $w('#getStartedButton').label,
        targetUrl: $w('#getStartedButton').link,
    }, ]

    ctas.forEach((cta) => {
        const {
            id,
            ctaName,
            targetUrl,
        } = cta
        $w(id).onClick(() => {
            const biFields = {
                ctaName,
                targetUrl,
                pageUrl,
            }
            fireBIEvent(19, 9001, biFields);
        });
    });
}

//event 9002 
const clickOnSecondaryCtaBiEvent = () => {

    const ctas = [{
            id: '#watchFullCourseBtn',
            ctaCategory: 'Take you first steps with the Wix Editor',
            ctaName: $w('#watchFullCourseBtn').label,
            targetUrl: $w('#watchFullCourseBtn').link
        },
        {
            id: '#goToChecklistBtn',
            ctaCategory: 'Not sure where to begin?',
            ctaName: $w('#goToChecklistBtn').label,
            targetUrl: $w('#goToChecklistBtn').link
        },
        {
            id: '#watchNowBtn',
            ctaCategory: 'Webinar',
            ctaName: $w('#watchNowBtn').label,
            targetUrl: $w('#watchNowBtn').link
        },
        {
            id: '#buildAnExpertTxt',
            ctaCategory: 'Inspiration',
            ctaName: $w('#buildAnExpertTxt').text,
            targetUrl: 'https://www.wix.com/blog/2021/10/how-to-make-business-website',
        },

        {
            id: '#getInspiredByTxt',
            ctaCategory: 'Inspiration',
            ctaName: $w('#getInspiredByTxt').text,
            targetUrl: 'https://www.wix.com/blog/creative/2018/09/best-website-designs',
        },
        {
            id: '#understandAllTxt',
            ctaCategory: 'Inspiration',
            ctaName: $w('#understandAllTxt').text,
            targetUrl: 'https://www.wix.com/blog/2021/02/how-to-make-a-website',
        },
        {
            id: '#discoverMoreOnBtn',
            ctaCategory: 'Inspiration',
            ctaName: $w('#discoverMoreOnBtn').label,
            targetUrl: $w('#discoverMoreOnBtn').link,
        },

        {
            id: '#chatButton',
            ctaCategory: 'Support',
            ctaName: $w('#chatButton').label,
            targetUrl: $w('#chatButton').link,
        },
        {
            id: '#hireButton',
            ctaCategory: 'Support',
            ctaName: $w('#hireButton').label,
            targetUrl: $w('#hireButton').link,
        },
    ]

    ctas.forEach((cta) => {

        const {
            id,
            ctaCategory,
            ctaName,
            targetUrl,
        } = cta;
        console.log(cta);
        $w(id).onClick(() => {
            // console.log("cta-click");
            const biFields = {
                ctaName,
                targetUrl,
                ctaCategory,

            }
            fireBIEvent(19, 9002, biFields);
        });
    });
}

//event 9050,9051,9052,9053 
const watchVideoBiEvent = () => {
    const videoId = ['4', '5', '6'];
    videoId.forEach((index) => {
        let id = `#videoPlayer${index}`;
        const biFields = {
            videoName: $w(id).title || $w(id).description,
            videoUrl: $w(id).src,
            pageUrl: pageUrl,
        }
        $w(id).onPlay(() => {
            fireBIEvent(19, 9050, biFields);
        });
        let fiveSecondFlag = false;
        let fiftyPercentFlag = false;
        let ninetyPercentFlag = false;
        $w(id).onProgress((e) => {
            let currentTime = e.target.currentTime;
            let duration = e.target.duration;
            if (currentTime > 5 && !fiveSecondFlag) {
                fireBIEvent(19, 9051, biFields)
                fiveSecondFlag = true;
                console.log('5 sec')
            }
            if (duration / currentTime < 2 && !fiftyPercentFlag) {
                fireBIEvent(19, 9052, biFields);
                fiftyPercentFlag = true;
                console.log('50 percent')
            }
            if (currentTime / duration >= 0.9 && !ninetyPercentFlag) {
                fireBIEvent(19, 9053, biFields);
                ninetyPercentFlag = true;
                console.log('90 percent')
            }

        })
    });
}